export const classNames = (...names) => {
  return names.filter(n => n !== undefined && n != null)
              .map(n => String(n).trim())
              .filter(n => n)
              .join(' ');
};



// WEBPACK FOOTER //
// ./src/main/functions/classNames.js